import {
  SET_UNINSTALL_CATEGORY,
  SET_MIX_BATCH_DETAILS,
  SET_RRSIDUAL_LIST,
  SET_TEMP_RRSIDUAL_LIST,
  MODIFY_RESIDUAL_DATA,
  ADD_TEMP_RESIDUAL_SUCC,
  REMOVE_TEMP_RESIDUAL,
  REMOVE_TRESIDUAL,
} from '../constants/unintall';

const initState = {
  categoryList: [],
  softsDetail: [],
  residualDetail: [],
  residualList: [],
  tempResidualList: [],
  clearStatus: {
    CLEAR_ERR: 'CLEAR_ERR', // 残留清理失败
    CLEAR_SUCC: 'CLEAR_SUCC', // 残留清理成功
    init: 'init', // 显示残留情况
    SCANING: 'SCANING', // 扫描中
    LOADING: 'LOADING', // 残留清理
  },
};

const user = (state = initState, action = {}) => {
  switch (action.type) {
    case SET_UNINSTALL_CATEGORY:
      return { ...state, categoryList: action.payload };
    case SET_MIX_BATCH_DETAILS:
      return { ...state, ...action.payload };
    case SET_RRSIDUAL_LIST:
      return { ...state, residualList: action.payload };
    case SET_TEMP_RRSIDUAL_LIST:
      return { ...state, tempResidualList: action.payload };
    case MODIFY_RESIDUAL_DATA:
      // eslint-disable-next-line no-case-declarations
      const {
        payload: { softGUID },
      } = action;
      // eslint-disable-next-line no-case-declarations
      const residualLists = state.residualList.map(item => {
        if (item.softGUID === softGUID) {
          return {
            ...item,
            ...action.payload,
          };
        }
        return item;
      });
      // eslint-disable-next-line no-case-declarations
      const tempResidualLists = state.tempResidualList.map(item => {
        if (item.softGUID === softGUID) {
          return {
            ...item,
            ...action.payload,
          };
        }
        return item;
      });
      return {
        ...state,
        residualList: residualLists,
        tempResidualList: tempResidualLists,
      };
    case ADD_TEMP_RESIDUAL_SUCC:
      // eslint-disable-next-line no-case-declarations
      const residualInfo = state.tempResidualList.find(
        item => item.softGUID === action.payload.softGUID,
      );
      // eslint-disable-next-line no-case-declarations
      let list = state.tempResidualList;
      // 不存在此条信息
      if (!residualInfo) {
        list = [action.payload, ...state.tempResidualList];
      }
      return {
        ...state,
        tempResidualList: list,
      };
    case REMOVE_TEMP_RESIDUAL:
      return {
        ...state,
        tempResidualList: state.tempResidualList.filter(
          item => item.softGUID !== action.payload.softGUID,
        ),
      };
    case REMOVE_TRESIDUAL:
      return {
        ...state,
        residualList: state.residualList.filter(item => item.softGUID !== action.payload.softGUID),
      };
    default:
      return state;
  }
};

export default user;
